import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const IncreaseHighGrowth = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#clip0_1459_158)">
      <Path
        d="M6 20.99c-.24 0-.48-.1-.65-.31a.828.828 0 01.12-1.17l7.24-5.91-3.05-1.38a.835.835 0 01-.48-.64c-.04-.28.06-.56.27-.75l6.83-5.99H13.9c-.46 0-.83-.37-.83-.83 0-.46.37-.83.83-.83h4.64c.18 0 .34.07.47.18 0 0 .08.07.12.11.12.14.2.33.2.54v4.6c0 .46-.37.83-.83.83-.46 0-.83-.37-.83-.83V5.86l-6.13 5.38 3.1 1.4a.83.83 0 01.18 1.4L6.54 20.8c-.16.13-.34.19-.53.19H6z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1459_158">
        <Path fill="#fff" d="M0 0H24V24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default IncreaseHighGrowth
